import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { faAngleDown, faAngleRight, faDownload } from '@fortawesome/free-solid-svg-icons';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Medium, MediumVersion } from 'src/api/generated';
import { MachineMediumService } from 'src/app/shared/services/machine-medium.service';
import { MessagesService } from 'src/app/shared/services/messages.service';
import { confirm } from 'devextreme/ui/dialog';
import { TranslateWithFallbackPipe } from 'acl-cloud-lib';

@Component({
  selector: 'app-machine-medium',
  templateUrl: './machine-medium.component.html',
  styleUrl: './machine-medium.component.scss'
})
export class MachineMediumComponent {
  faDownload = faDownload;
  faAngleDown = faAngleDown;
  faAngleRight = faAngleRight;
  public verDataSource: any[] = [];
  private _unsubscriber = new Subject();
  public actualVersion: number = 0;
  isSmallScreen: boolean = false;
  isShowed: { [key: string]: boolean } = {};
  downloadLoading: boolean = false;

  @Input()
  currentMachineId!: Observable<string | undefined>;

  constructor(
    private _mSvc: MachineMediumService,
    private breakpointObserver: BreakpointObserver,
    private _messSvc: MessagesService,
    private readonly _medSvc: MachineMediumService,
    private readonly _translate: TranslateWithFallbackPipe
  ) {
    _mSvc.medVerSrc$.pipe(takeUntil(this._unsubscriber)).subscribe({
      next: res => {
        this.verDataSource = res;
        this.actualVersion = Math.max(...this.verDataSource.map(function (ver: MediumVersion) { return ver.Version ?? 0; }));
      },
      error: (err: HttpErrorResponse) => {
        this._messSvc.ShowError(JSON.stringify(err));
        console.error(err);
      }
    });
  }

  ngOnInit(): void {
    this._mSvc.IsActive = true;

    this.currentMachineId.subscribe(id => {
      if(id) {
        this._mSvc.CurrentRowId = id;
      }
    });

    this.breakpointObserver
      .observe([Breakpoints.HandsetPortrait])
      .subscribe((state: BreakpointState) => {
        this.isSmallScreen = state.matches;
      });
  }

  ngOnDestroy(): void {
    this._unsubscriber.next(null);
    this._unsubscriber.complete();
    this._mSvc.IsActive = false;
  }

  onFocusedRowChanged(e: any) {
    let rowData: Medium;
    if (e.hasOwnProperty('row')) {
      rowData = e.row && e.row.data;
    } else {
      rowData = e;
    }

    if (rowData) {
      this._mSvc.CurrentRow = rowData;
    }
  }

  public get MSvc(): MachineMediumService {
    return this._mSvc;
  }


  public checkout(rowData: MediumVersion): void {
    if (rowData) {
      var medVer = rowData as MediumVersion;
      if(medVer.Id){
        this._mSvc.Checkout(medVer.Id);
      } else {
        this._messSvc.ShowError(this._translate.transform('machine-medium-checkout-error'));
      }
    }
  }

  private _downloadFile(data: any) {
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    a.download = data.fileName;
    a.href = URL.createObjectURL(data.file);
    a.target = '_blank';
    a.click();
    document.body.removeChild(a);
  }


  public async delete(rowData: Medium): Promise<void> {
    if (rowData?.Id && await confirm(this._translate.transform('machine-medium-remove-question'), this._translate.transform('delete-confirmation'))) {
      this._mSvc.Delete(rowData.Id);
    }
  }

  download(rowData: Medium): void {
    if (rowData && rowData.Id) {
      this.downloadLoading = true;
      this._medSvc.downloadMediumVersionByIdMedium(rowData.Id).subscribe({
        next: (data) => {
          this._downloadFile(data);
          this.downloadLoading = false;
        },
        error: (e) => {
          this._messSvc.ShowError(JSON.stringify(e));
          this.downloadLoading = false;
        }
      });
    }
  }

  public OnRowPrepared(e: any) {
    if (e.data && e.data.Version === this.actualVersion) {
        e.rowElement.style.background = "#5391C8";
        e.rowElement.style.color = "white";
    }
  }

  show(rowIndex: string): void {
    this.isShowed[rowIndex] = !this.isShowed[rowIndex];
  }
}
